import { defineComponent as _, useTemplateRef as b, createBlock as y, openBlock as w, unref as s, withCtx as n, createElementVNode as i, toDisplayString as m, createVNode as u, createTextVNode as p } from "vue";
import { ScalarModal as C, ScalarButton as d } from "@scalar/components";
import { emitCustomEvent as S } from "@scalar/workspace-store/events";
const g = { class: "text-c-2 mb-4 text-sm leading-normal" }, k = { class: "flex justify-between gap-2" }, B = /* @__PURE__ */ _({
  __name: "DeleteRequestAuthModal",
  props: {
    state: {},
    scheme: {}
  },
  emits: ["close", "delete"],
  setup(f, { emit: h }) {
    const l = f, r = h, x = () => {
      var t, e;
      (t = l.scheme) != null && t.id && S((e = a.value) == null ? void 0 : e.$el, "scalar-delete-security-scheme", {
        uid: l.scheme.id
      }), r("delete");
    }, a = b("wrapperRef");
    return (t, e) => (w(), y(s(C), {
      ref_key: "wrapperRef",
      ref: a,
      size: "xxs",
      state: t.state,
      title: "Delete Security Scheme"
    }, {
      default: n(() => {
        var c;
        return [
          i("p", g, " This cannot be undone. You're about to delete the " + m((c = t.scheme) == null ? void 0 : c.label) + " security scheme from the collection. ", 1),
          i("div", k, [
            u(s(d), {
              class: "flex h-8 cursor-pointer items-center gap-1.5 px-3 shadow-none focus:outline-none",
              type: "button",
              variant: "outlined",
              onClick: e[0] || (e[0] = (o) => r("close"))
            }, {
              default: n(() => e[1] || (e[1] = [
                p(" Cancel ")
              ])),
              _: 1,
              __: [1]
            }),
            u(s(d), {
              class: "flex h-8 cursor-pointer items-center gap-1.5 px-3 shadow-none focus:outline-none",
              type: "submit",
              onClick: x
            }, {
              default: n(() => {
                var o;
                return [
                  p(" Delete " + m((o = t.scheme) == null ? void 0 : o.label), 1)
                ];
              }),
              _: 1
            })
          ])
        ];
      }),
      _: 1
    }, 8, ["state"]));
  }
});
export {
  B as default
};
